import React from "react";

const ReturnHistoryIcon = () => {
  return (
<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 11.5V5.375L10 1H5C4.46957 1 3.96086 1.18437 3.58579 1.51256C3.21071 1.84075 3 2.28587 3 2.75V11.5C3 11.9641 3.21071 12.4092 3.58579 12.7374C3.96086 13.0656 4.46957 13.25 5 13.25H13C13.5304 13.25 14.0391 13.0656 14.4142 12.7374C14.7893 12.4092 15 11.9641 15 11.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 4.5V8H12M3 2.75C2.46957 2.75 1.96086 2.93437 1.58579 3.26256C1.21071 3.59075 1 4.03587 1 4.5V13.25C1 13.7141 1.21071 14.1592 1.58579 14.4874C1.96086 14.8156 2.46957 15 3 15H11C11.5304 15 12.0391 14.8156 12.4142 14.4874C12.7893 14.1592 13 13.7141 13 13.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
};

export default ReturnHistoryIcon;